import styled from 'styled-components'

export const ShootDateWrapper = styled.span`
    text-transform: capitalize;
`
